module.exports = __webpack_public_path__ + "static/media/book4.b12a321a.jpg";